
export const capitalize = (text) => text && text.toLowerCase().replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());

const isAlpha = (ch) => (/[a-zA-Z]/).test(ch);

export const capitalizeFirstLetterofWord = (text) => {
  if (text && isAlpha(text)) {
    const words = text.toLowerCase().split(' ');
    if (words.length > 0) {
      return words.map((word) => (word?.[0]?.toUpperCase() || '') + word?.slice(1)).join(' ');
    }
  }
  return text;
};
export const capitalizeFirstLetterofWordPlans = (text) => {
  if (text && isAlpha(text)) {
    const words = text.toLowerCase().replace('5g', '5G').split(' ');
    if (words.length > 0) {
      return words.map((word) => (word?.[0]?.toUpperCase() || '') + word?.slice(1)).join(' ');
    }
  }
  return text;
};

export const capitalizeFirstLetter = (text) => {
  let result = '';
  const text1 = text?.split(',');
  for (let i = 0; i < text1?.length; i++) {
    const textNew = text1[i].split(' ');
    let isFirstCaps = false;
    for (let j = 0; j < textNew.length; j++) {
      if (isAlpha(textNew[j].charAt(0)) && !isFirstCaps) {
        result += `${textNew[j].charAt(0).toUpperCase() + textNew[j].slice(1).toLowerCase()} `;
        isFirstCaps = true;
      } else {
        result += `${textNew[j].toLowerCase()} `;
      }
    }
    if (i !== text1.length - 1) {
      result += ',';
    }
  }
  return result;
};

export const toTitleCase = (str) => str.replace(
  /\w\S*/g,
  (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
);
